var React = require('react');

function ContactTrianglesMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M146.055 318.646L132.337 240.397M146.055 318.646L106.062 283.2M146.055 318.646L60.1359 274.058M132.337 240.397L106.062 283.2M132.337 240.397L60.1359 274.058M106.062 283.2L60.1359 274.058","stroke":"#FF9EB6","key":0}),React.createElement("path",{"d":"M1 7.04395L12.1965 53.8043M1 7.04395L25.9537 26.9516M1 7.04395L53.3503 30.7421M12.1965 53.8043L25.9537 26.9516M12.1965 53.8043L53.3503 30.7421M25.9537 26.9516L53.3503 30.7421","stroke":"#FF9EB6","key":1})]);
}

ContactTrianglesMobile.defaultProps = {"width":"147","height":"323","viewBox":"0 0 147 323","fill":"none"};

module.exports = ContactTrianglesMobile;

ContactTrianglesMobile.default = ContactTrianglesMobile;
